import React from 'react';
import { useSelector } from 'react-redux';
import { getFinalStage } from '../../../../ui/builders/utils';
import { isCharedi } from '../../../../utils/utils';
import Icon from '../../../ui/icons/Icon';
import iconsList from '../../../ui/icons/iconsList';
import classes from './FinalDateComp.module.css';

const FinalDateComp = () => {

  const { texts } = useSelector((state) => state.translate);
  const { finalData, contentInfoJson } = useSelector((state) => state.contest);
  const finalStage = getFinalStage(useSelector((state) => state.contest));
  const dateObj = new Date(finalStage?.startDate);
  const displayDate = dateObj?.toLocaleDateString("he-IL", { day: "2-digit", month: "2-digit" }) ?? '';
  const time = dateObj?.toLocaleTimeString("he-IL", { hour: "2-digit", minute: "2-digit" }) ?? '';


  return (
    <div className={classes.finalDate} >
      <div className={classes.row} >
        <div className={classes.dateBlock}>
          <div className={classes.labelBlock}>
            <span className={classes.label}>{isCharedi() ? texts.finalOnDayLabelCharedi : texts.finalOnDayLabel}</span>
            <Icon name={iconsList.calendar} className={classes.icon} color="#070C43" />
          </div>
          <div className={classes.date}>
            <span className={classes.pill}> <p className={classes.pillText}>{displayDate}</p></span>
            <span className={classes.pill}><p className={classes.pillText}>{texts[contentInfoJson?.final?.finalHebrewDate]}</p></span>
          </div>
        </div>
        <div className={classes.dateBlock}>
          <div className={classes.labelBlock}>
            <span className={classes.label}>{isCharedi() ? texts.startsAtTimeLabelCharedi : texts.startsAtTimeLabel}</span>
            <Icon name={iconsList.clock} className={classes.icon} color="#070C43" />
          </div>
          <span className={classes.pill}><p className={classes.pillText}>{time}</p></span>
        </div>
      </div>
    </div>
  );
};

export default FinalDateComp;
